import React from 'react';

const Header = () => {
   return (
       <div className="header">
          <h1>Todos List App</h1>


           </div>
   )

}
export default Header;